module.exports = __webpack_public_path__ + "img/folder.79bd9932.jpg";